import { SimpleMerchant } from "../interfaces/Merchant"
import { CustomField } from "../interfaces/Settings"
import { SimpleMeeting } from "../interfaces/Meeting"
import { SimplePipeline } from "../interfaces/Pipeline"
import { SimpleProduct } from "../interfaces/Product"

// kumpulan function untuk mengambil data template id master (pipeline, meeting, merchant) apa saja yang di tambahkan ke custom field, dan memfilter data berdasarkan template id tersebut

export const getSelectedValueCustomFieldMeeting = (customFieldGeneral: CustomField, simpleMeetings: SimpleMeeting[], key: string) => {
    let filteredMeetings = simpleMeetings
    if ((customFieldGeneral[key].value as string[]).length > 0 && !(customFieldGeneral[key].value as string[]).includes('all')) {
        filteredMeetings = simpleMeetings.filter((meeting: SimpleMeeting) => (customFieldGeneral[key].value as string[]).includes(meeting.meetingTemplateId!))
    }
    return filteredMeetings
}

export const getSelectedValueCustomFieldMerchant = (customFieldGeneral: CustomField, simpleMerchants: SimpleMerchant[], key: string) => {
    let filteredMerchants = simpleMerchants
    if ((customFieldGeneral[key].value as string[]).length > 0 && !(customFieldGeneral[key].value as string[]).includes('all')) {
        filteredMerchants = simpleMerchants.filter((merchant: SimpleMerchant) => (customFieldGeneral[key].value as string[]).includes(merchant.merchantTemplateId!))
    }
    return filteredMerchants
}

export const getSelectedValueCustomFieldPipeline = (customFieldGeneral: CustomField, simplePipelines: SimplePipeline[], key: string) => {
    let filteredPipelines = simplePipelines
    if ((customFieldGeneral[key].value as string[]).length > 0 && !(customFieldGeneral[key].value as string[]).includes('all')) {
        filteredPipelines = simplePipelines.filter((pipeline: SimplePipeline) => (customFieldGeneral[key].value as string[]).includes(pipeline.leadTemplateId!))
    }
    return filteredPipelines
}

export const getSelectedValueCustomFieldProduct = (customFieldGeneral: CustomField, simpleProducts: SimpleProduct[], key: string) => {
    let filteredPipelines = simpleProducts
    if ((customFieldGeneral[key].value as string[]).length > 0 && !(customFieldGeneral[key].value as string[]).includes('all')) {
        filteredPipelines = simpleProducts.filter((product: SimpleProduct) => (customFieldGeneral[key].value as string[]).includes(product.id!))
    }
    return filteredPipelines
}